import { useEffect, useState } from 'react';

import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import { useFormContext } from 'react-hook-form';

import { useGetStudentLedger } from 'api/hooks/private/users/students/GetStudentLedger';

import FinanceSummaryItem from 'components/Dialogs/components/FinanceSummaryItem';

import { formatCents } from 'utils/formatCurrency';

import { ChargeFormValues, DiscountFieldValue } from '../ChargeSchema';

function ChargeSummary() {
  const [newBalance, setNewBalance] = useState(0);
  const {
    watch,
    formState: { errors },
  } = useFormContext<ChargeFormValues>();

  const { data: studentLedger } = useGetStudentLedger({
    variables: {
      id: watch('student_user_id'),
      showVoided: true,
    },
    initialData: [],
  });

  const amount = watch('amount') ?? 0;
  const deposit = watch('deposit') ?? 0;
  const discounts = watch('student_charge_discounts') ?? [];

  console.log('Amount: ', amount);
  console.log('Deposit: ', deposit);
  console.log('Discounts: ', discounts);

  const finalTotal = discounts?.reduce(
    (accumulator, discount: DiscountFieldValue) => {
      if (discount?.type === 'fixed') {
        return {
          discountTotal: accumulator.discountTotal + discount?.amount,
          discountedTotal: Math.max(0, accumulator.discountedTotal - discount?.amount),
        };
      }

      if (discount?.type === 'percentage') {
        const discountAmount = (discount?.amount / 100) * accumulator.discountedTotal;
        return {
          discountTotal: accumulator.discountTotal + discountAmount,
          discountedTotal: Math.max(0, accumulator.discountedTotal - discountAmount),
        };
      }

      return accumulator;
    },
    {
      discountTotal: 0,
      discountedTotal: amount,
    },
  );

  useEffect(() => {
    // wait until the ledger is fetched
    if (!studentLedger) return;

    // calculate the new account balance excluding the current charge
    const currentChargeId = watch('id');
    const prevChargeAmount = Number(studentLedger?.find((entry) => entry.id === currentChargeId)?.amount ?? 0);
    const currentBalance = Number(studentLedger[studentLedger.length - 1]?.balance ?? 0);

    setNewBalance(currentBalance - prevChargeAmount + finalTotal?.discountedTotal);
  }, [finalTotal, studentLedger, watch]);

  return (
    <Grid container rowSpacing={0} columnSpacing={3}>
      <FinanceSummaryItem title="Subtotal" value={formatCents(amount)} />
      <FinanceSummaryItem title="Discounts" value={formatCents(finalTotal?.discountTotal)} />
      <Grid size={12} py={1}>
        <Divider />
      </Grid>
      <FinanceSummaryItem title="Total" value={formatCents(finalTotal?.discountedTotal)} />
      <FinanceSummaryItem title="Deposit" value={formatCents(deposit)} error={!!errors['deposit']} />
      <Grid size={12} py={1}>
        <Divider />
      </Grid>
      <FinanceSummaryItem title="New Student Balance" value={formatCents(newBalance)} />
    </Grid>
  );
}

export default ChargeSummary;
